// extracted by mini-css-extract-plugin
module.exports = {"Accordion":"Accordion_Accordion__169tE","Header":"Accordion_Header__3hpHX","HeaderContent":"Accordion_HeaderContent__2YkEY"};